(function () {
  document.documentElement.classList.remove('no-js');

  /* ============================================================
     Mobile drawer / menu
     ============================================================ */

  function getDrawer() {
    return document.querySelector('[data-mobile-drawer]');
  }

  function getMenuToggle() {
    return document.querySelector('[data-menu-toggle]');
  }

  function setDrawerOpen(open) {
    const drawer = getDrawer();
    const toggle = getMenuToggle();

    if (!drawer) return;

    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('wc-drawer-open', open);

    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function toggleDrawer() {
    const drawer = getDrawer();
    const isOpen = drawer && drawer.classList.contains('is-open');

    setDrawerOpen(!isOpen);
  }

  /* ============================================================
     Search drawer / popup
     ============================================================ */

  function getSearchDrawer() {
    return document.querySelector('[data-wc-search-drawer]');
  }

  function getSearchOpenButtons() {
    return document.querySelectorAll('[data-wc-search-open]');
  }

  function setSearchOpen(open) {
    const searchDrawer = getSearchDrawer();
    const searchInput = document.querySelector('[data-wc-search-input]');
    const searchOpenButtons = getSearchOpenButtons();

    if (!searchDrawer) return;

    searchDrawer.classList.toggle('is-open', open);
    searchDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('wc-search-open', open);

    searchOpenButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (open) {
      setDrawerOpen(false);
      closeAccountMenu();
      closeCartMenu();

      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 180);
    }
  }

  /* ============================================================
     Account popup
     ============================================================ */

  function getAccountToggle() {
    return document.querySelector('[data-wc-account-toggle]');
  }

  function getAccountMenu() {
    return document.querySelector('[data-wc-account-menu]');
  }

  function closeAccountMenu() {
    const accountToggle = getAccountToggle();
    const accountMenu = getAccountMenu();

    if (!accountToggle || !accountMenu) return;

    accountToggle.setAttribute('aria-expanded', 'false');
    accountMenu.hidden = true;
  }

  function toggleAccountMenu() {
    const accountToggle = getAccountToggle();
    const accountMenu = getAccountMenu();

    if (!accountToggle || !accountMenu) return;

    const isOpen = accountToggle.getAttribute('aria-expanded') === 'true';

    accountToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    accountMenu.hidden = isOpen;

    if (!isOpen) {
      setDrawerOpen(false);
      setSearchOpen(false);
      closeCartMenu();
    }
  }

  /* ============================================================
     Cart popup
     ============================================================ */

  function getCartToggle() {
    return document.querySelector('[data-wc-cart-toggle]');
  }

  function getCartMenu() {
    return document.querySelector('[data-wc-cart-menu]');
  }

  function closeCartMenu() {
    const cartToggle = getCartToggle();
    const cartMenu = getCartMenu();

    if (!cartToggle || !cartMenu) return;

    cartToggle.setAttribute('aria-expanded', 'false');
    cartMenu.hidden = true;
  }

  function toggleCartMenu() {
    const cartToggle = getCartToggle();
    const cartMenu = getCartMenu();

    if (!cartToggle || !cartMenu) return;

    const isOpen = cartToggle.getAttribute('aria-expanded') === 'true';

    cartToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    cartMenu.hidden = isOpen;

    if (!isOpen) {
      setDrawerOpen(false);
      setSearchOpen(false);
      closeAccountMenu();
    }
  }

  /* ============================================================
     Click events
     ============================================================ */

  document.addEventListener('click', function (event) {
    const menuToggle = event.target.closest('[data-menu-toggle]');
    const bottomMenuTrigger = event.target.closest('[data-wc-bottom-menu-trigger]');
    const menuClose = event.target.closest('[data-menu-close]');

    const searchOpen = event.target.closest('[data-wc-search-open]');
    const searchClose = event.target.closest('[data-wc-search-close]');

    const accountToggle = event.target.closest('[data-wc-account-toggle]');
    const accountWrap = event.target.closest('[data-wc-account-wrap]');

    const cartToggle = event.target.closest('[data-wc-cart-toggle]');
    const cartWrap = event.target.closest('[data-wc-cart-wrap]');

    if (menuToggle || bottomMenuTrigger) {
      event.preventDefault();
      toggleDrawer();
      setSearchOpen(false);
      closeAccountMenu();
      closeCartMenu();
      return;
    }

    if (menuClose) {
      event.preventDefault();
      setDrawerOpen(false);
      return;
    }

    if (searchOpen) {
      event.preventDefault();
      setSearchOpen(true);
      return;
    }

    if (searchClose) {
      event.preventDefault();
      setSearchOpen(false);
      return;
    }

    if (accountToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleAccountMenu();
      return;
    }

    if (cartToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleCartMenu();
      return;
    }

    if (!accountWrap) {
      closeAccountMenu();
    }

    if (!cartWrap) {
      closeCartMenu();
    }
  });

  /* ============================================================
     Keyboard events
     ============================================================ */

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setDrawerOpen(false);
      setSearchOpen(false);
      closeAccountMenu();
      closeCartMenu();
    }
  });

  /* ============================================================
     Sort select
     ============================================================ */

  document.addEventListener('change', function (event) {
    const sort = event.target.closest('[data-sort-select]');

    if (sort && sort.form) {
      sort.form.submit();
    }
  });

  /* ============================================================
     Sticky header state
     ============================================================ */

  const stickyShell = document.querySelector('[data-sticky-header-shell]');
  const desktopStickyHeaderQuery = window.matchMedia('(min-width: 990px)');
  let stickyHeaderScrolled = false;
  let stickyHeaderTicking = false;
  let desktopStickyThreshold = 0;

  function syncStickyHeaderMetrics() {
    if (!stickyShell) return;

    const header = stickyShell.querySelector('[data-header]');
    const topbar = stickyShell.querySelector('.wc-topbar');
    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;

    desktopStickyThreshold = topbar
      ? Math.ceil(topbar.getBoundingClientRect().height)
      : 0;

    if (headerHeight > 0) {
      stickyShell.style.setProperty('--wc-sticky-header-height', `${headerHeight}px`);
    }
  }

  function setStickyHeaderState(nextState) {
    if (!stickyShell || stickyHeaderScrolled === nextState) return;

    stickyHeaderScrolled = nextState;
    stickyShell.classList.toggle('is-scrolled', nextState);
  }

  function updateStickyHeader() {
    if (!stickyShell) return;

    const scrollTop = window.scrollY || window.pageYOffset || 0;

    if (desktopStickyHeaderQuery.matches) {
      const threshold = Math.max(desktopStickyThreshold, 1);
      setStickyHeaderState(scrollTop >= threshold);
      return;
    }

    if (!stickyHeaderScrolled && scrollTop > 16) {
      setStickyHeaderState(true);
    } else if (stickyHeaderScrolled && scrollTop < 4) {
      setStickyHeaderState(false);
    }
  }

  function requestStickyHeaderUpdate() {
    if (stickyHeaderTicking) return;

    stickyHeaderTicking = true;

    window.requestAnimationFrame(function () {
      updateStickyHeader();
      stickyHeaderTicking = false;
    });
  }

  function refreshStickyHeader() {
    syncStickyHeaderMetrics();
    requestStickyHeaderUpdate();
  }

  syncStickyHeaderMetrics();
  updateStickyHeader();

  window.addEventListener('scroll', requestStickyHeaderUpdate, { passive: true });
  window.addEventListener('resize', refreshStickyHeader);
  window.addEventListener('load', refreshStickyHeader);

    /* ============================================================
     Tablet / touch desktop mega menu
     ============================================================ */

  function initTouchDesktopMegaMenu() {
    const nav = document.querySelector('.wc-nav');

    if (!nav || nav.dataset.wcTouchMegaReady === 'true') {
      return;
    }

    nav.dataset.wcTouchMegaReady = 'true';

    const touchNavQuery = window.matchMedia('(hover: none), (pointer: coarse)');

    function isTouchNavigation() {
      return (
        touchNavQuery.matches ||
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0
      );
    }

    function closeAllMegaMenus(exceptItem) {
      nav.querySelectorAll('.wc-nav__item.is-open').forEach(function (item) {
        if (item !== exceptItem) {
          item.classList.remove('is-open');

          const link = item.querySelector(':scope > .wc-nav__link');

          if (link) {
            link.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    function openMegaMenu(item) {
      item.classList.add('is-open');

      const link = item.querySelector(':scope > .wc-nav__link');

      if (link) {
        link.setAttribute('aria-expanded', 'true');
      }
    }

    function closeMegaMenu(item) {
      item.classList.remove('is-open');

      const link = item.querySelector(':scope > .wc-nav__link');

      if (link) {
        link.setAttribute('aria-expanded', 'false');
      }
    }

    nav.querySelectorAll('.wc-nav__item.has-dropdown > .wc-nav__link').forEach(function (link) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
    });

    nav.addEventListener('click', function (event) {
      const link = event.target.closest('.wc-nav__link');

      if (!link || !nav.contains(link)) {
        return;
      }

      const item = link.closest('.wc-nav__item.has-dropdown');

      if (!item || !isTouchNavigation()) {
        return;
      }

      /*
        First tap opens the mega/submenu.
        Second tap on the same top-level link follows the href.
      */
      if (!item.classList.contains('is-open')) {
        event.preventDefault();
        event.stopPropagation();

        closeAllMegaMenus(item);
        openMegaMenu(item);
      }
    });

    document.addEventListener('click', function (event) {
      if (!isTouchNavigation()) {
        return;
      }

      if (event.target.closest('.wc-nav')) {
        return;
      }

      closeAllMegaMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllMegaMenus();
      }
    });

    window.addEventListener('resize', function () {
      if (!isTouchNavigation()) {
        closeAllMegaMenus();
      }
    });
  }

  initTouchDesktopMegaMenu();
})();
/* ============================================================
   Homepage mobile UI visibility
   Shows header/chat after user starts scrolling
   ============================================================ */

(function () {
  var body = document.body;

  if (!body || !body.classList.contains('template-index')) {
    return;
  }

  function updateHomeUiVisibility() {
    if (window.innerWidth > 749) {
      body.classList.add('wc-home-ui-visible');
      return;
    }

    if (window.scrollY > 40) {
      body.classList.add('wc-home-ui-visible');
    } else {
      body.classList.remove('wc-home-ui-visible');
    }
  }

  updateHomeUiVisibility();

  window.addEventListener('scroll', updateHomeUiVisibility, { passive: true });
  window.addEventListener('resize', updateHomeUiVisibility);
})();